// Copyright (c) Microsoft. All rights reserved.

import { FC, useState } from 'react';

import { Button, Spinner, makeStyles } from '@fluentui/react-components';
import { useChat } from '../../../../libs/hooks';
import { Edit } from '../../../shared/BundledIcons';
import { InvitationJoinDialog } from '../../invitation-dialog/InvitationJoinDialog';

const useClasses = makeStyles({
    newChat: {
        margin: '8px',
    },
});

interface SimplifiedNewBotMenuProps {
    onFileUpload: () => void;
    selectedAgentId: string;
}

export const SimplifiedNewBotMenu: FC<SimplifiedNewBotMenuProps> = ({ selectedAgentId }) => {
    const chat = useChat();
    const classes = useClasses();

    const [isJoiningBot, setIsJoiningBot] = useState(false);
    const [isCreating, setIsCreating] = useState(false);

    const onAddChat = () => {
        setIsCreating(true);
        void chat.createChat(selectedAgentId).finally(() => {
            setIsCreating(false);
        });
    };

    const onCloseDialog = () => {
        setIsJoiningBot(false);
    };

    return (
        <div className={classes.newChat}>
            <Button
                data-testid="createNewConversationButton"
                icon={isCreating ? <Spinner size="tiny" /> : <Edit />}
                onClick={onAddChat}
                appearance="subtle"
                disabled={isCreating}
            >
                {isCreating ? 'Sohbet açılıyor...' : 'Yeni sohbet başlat'}
            </Button>

            {isJoiningBot && <InvitationJoinDialog onCloseDialog={onCloseDialog} />}
        </div>
    );
};
